// Ödeme yöntemi tanımlarken seçilebilecek kripto para birimleri.
// `symbol` ödeme yöntemi kaydındaki `asset` alanına yazılır; ikon bu
// sembolden otomatik türetilir (bkz. components/PaymentMethodLogo.jsx).
// `networks` yalnızca panelde öneri olarak gösterilir — ağ alanı serbest
// metindir, sağlayıcı listede olmayan bir ağ isterse elle yazılabilir.
export const CRYPTO_ASSETS = [
  { symbol: 'USDT', name: 'Tether', networks: ['TRC20', 'ERC20', 'BEP20', 'SOL', 'POLYGON'] },
  { symbol: 'USDC', name: 'USD Coin', networks: ['ERC20', 'BEP20', 'SOL', 'POLYGON'] },
  { symbol: 'BTC', name: 'Bitcoin', networks: ['BTC', 'BEP20', 'LIGHTNING'] },
  { symbol: 'ETH', name: 'Ethereum', networks: ['ERC20', 'ARBITRUM', 'OPTIMISM', 'BEP20'] },
  { symbol: 'BNB', name: 'BNB', networks: ['BEP20', 'BEP2'] },
  { symbol: 'TRX', name: 'Tron', networks: ['TRC20'] },
  { symbol: 'SOL', name: 'Solana', networks: ['SOL'] },
  { symbol: 'XRP', name: 'XRP', networks: ['XRP'] },
  { symbol: 'LTC', name: 'Litecoin', networks: ['LTC'] },
  { symbol: 'DOGE', name: 'Dogecoin', networks: ['DOGE', 'BEP20'] },
  { symbol: 'ADA', name: 'Cardano', networks: ['ADA', 'BEP20'] },
  { symbol: 'AVAX', name: 'Avalanche', networks: ['AVAXC', 'BEP20'] },
  { symbol: 'MATIC', name: 'Polygon', networks: ['POLYGON', 'ERC20'] },
  { symbol: 'DOT', name: 'Polkadot', networks: ['DOT', 'BEP20'] },
  { symbol: 'SHIB', name: 'Shiba Inu', networks: ['ERC20', 'BEP20'] },
  { symbol: 'DAI', name: 'Dai', networks: ['ERC20', 'BEP20', 'POLYGON'] },
  { symbol: 'TON', name: 'Toncoin', networks: ['TON'] },
  { symbol: 'BCH', name: 'Bitcoin Cash', networks: ['BCH', 'BEP20'] },
  { symbol: 'XLM', name: 'Stellar', networks: ['XLM'] },
  { symbol: 'ETC', name: 'Ethereum Classic', networks: ['ETC', 'BEP20'] },
  { symbol: 'LINK', name: 'Chainlink', networks: ['ERC20', 'BEP20'] },
  { symbol: 'ATOM', name: 'Cosmos', networks: ['ATOM', 'BEP20'] },
  { symbol: 'NEAR', name: 'NEAR Protocol', networks: ['NEAR', 'BEP20'] },
  { symbol: 'APT', name: 'Aptos', networks: ['APT'] },
  { symbol: 'ARB', name: 'Arbitrum', networks: ['ARBITRUM', 'ERC20'] },
  { symbol: 'OP', name: 'Optimism', networks: ['OPTIMISM'] },
  { symbol: 'PEPE', name: 'Pepe', networks: ['ERC20'] },
  { symbol: 'FTM', name: 'Fantom', networks: ['FTM', 'BEP20'] },
  { symbol: 'ALGO', name: 'Algorand', networks: ['ALGO'] },
  { symbol: 'XMR', name: 'Monero', networks: ['XMR'] },
];

export const findCryptoAsset = (symbol) => CRYPTO_ASSETS.find(
  (asset) => asset.symbol === String(symbol || '').trim().toUpperCase(),
);

// Yöntem adı boş bırakıldığında kullanılan varsayılan görünen ad.
export const cryptoAssetLabel = (symbol) => {
  const asset = findCryptoAsset(symbol);
  return asset ? `${asset.name} (${asset.symbol})` : String(symbol || '');
};

export default CRYPTO_ASSETS;
